import React from 'react';

interface EditingState {
  editable: boolean;
  editing: boolean;
}

type SaveHandler = () => Promise<boolean>;

export interface EditingValue extends EditingState {
  setIsEditable: (isEditable: boolean) => void;
  setEditing: () => void;
  save: () => Promise<void>;
  addSaveHandler: (saveHandler: SaveHandler) => void;
  removeSaveHandler: (saveHandler: SaveHandler) => void;
}

export class Editable extends React.Component<{}> {
  state: EditingState = { editable: false, editing: false };
  private saveHandlers: SaveHandler[] = [];

  render() {
    return (
      <EditingContext.Provider
        value={{
          ...this.state,
          setIsEditable: (editable: boolean) => this.setState({ editable }),
          setEditing: () => this.setState({ editing: true }),
          save: async () => {
            for (const handler of this.saveHandlers) {
              const result = await handler();
              if (!result) {
                return; // TODO Show error.
              }
            }
            this.setState({ editing: false });
          },
          addSaveHandler: (saveHandler: SaveHandler) => {
            this.saveHandlers.push(saveHandler);
          },
          removeSaveHandler: (saveHandler: SaveHandler) => {
            const index = this.saveHandlers.indexOf(saveHandler);
            if (index !== -1) {
              this.saveHandlers.splice(index, 1);
            }
          },
        }}
      >
        {this.props.children}
      </EditingContext.Provider>
    );
  }
}

export class ContainsEditor extends React.Component<{}> {
  render() {
    return (
      <EditingContext.Consumer>
        {(editing) => (
          <InnerEditor setIsEditable={editing.setIsEditable}>{this.props.children}</InnerEditor>
        )}
      </EditingContext.Consumer>
    );
  }
}

class InnerEditor extends React.Component<{ setIsEditable: (isEditable: boolean) => void }> {
  componentDidMount() {
    this.props.setIsEditable(true);
  }

  componentWillUnmount() {
    this.props.setIsEditable(false);
  }

  render() {
    return this.props.children;
  }
}

export const EditingContext = React.createContext<EditingValue>(/* default= */ undefined);
